module.exports = __webpack_public_path__ + "img/note-like.53e9a1bd.png";